<template>
    <div>
        <button class="voucher-card" @click="handleClick">
          <img :src="voucher?.avatar?.image_url" class="background-image"/>
            <div class="content-box">
                <div class="text-content">
                    <div class="title-points">
                        <div>
                            <h3 class="voucher-title">{{ voucher.name }}</h3>
                            <p class="voucher-subtitle">
                                {{ voucher.branch?.name || voucher.merchant?.branch?.name || voucher.branch_name }} . 
                                {{ voucher.merchant?.name || voucher.merchant_name }}
                            </p>
                        </div>
                        <div v-if="!isModalActive" class="points-box">
                            <p class="points-text">{{ voucher.point }}</p>
                            <p class="points-label">Points</p>
                        </div>
                    </div>
                </div>
            </div>
        </button>

        <div v-if="isModalActive" class="modal-overlay" @click.self="closeModal">
            <div class="modal-content">
              <div class="modal-card">
                <button class="close-button" @click="closeModal">
                    &times;
                </button>
                <img :src="voucher?.avatar?.image_url" class="modal-voucher-image" alt="Voucher Image" />
              </div>
              <div class="modal-info-overlay">
                <div class="modal-info">
                  <div class="modal-content-box">
                      <h3 class="modal-voucher-title">{{ voucher.name }}</h3>
                      <p class="modal-voucher-subtitle">
                          {{ voucher.branch?.name || voucher.merchant?.branch?.name || voucher.branch_name }} . 
                          {{ voucher.merchant?.name || voucher.merchant_name }}
                      </p>
                  </div>
                  <div class="info-and-points-container d-flex align-items-start justify-content-between">
                      <div class="info-section">
                          <div class="info-subtitle" v-html="voucher.desc"></div>
                      </div>
                      <div class="points-box-container">
                          <p class="points-texts">{{ voucher.point }}</p>
                          <p class="points-labels">Points</p>
                      </div>
                  </div>
                  <div class="info-section centered-text">
                        <div class="points-and-button d-flex justify-content-center align-items-center">
                          <div v-if="isExpired">
                              <p style="color: #ff4b4b; font-size: 18px; font-weight: bold;">Can't redeem cause voucher expired</p>
                          </div>
                          <div v-else-if="hasNegativePoints">
                              <p style="color: #ff4b4b; font-size: 16px; font-weight: bold; text-align: center; line-height: 1.4;">
                                  Your points are negative. Please complete transactions to make your points positive before accessing vouchers.
                              </p>
                          </div>
                          <o-button 
                              v-else
                              :disabled="isLoading || isVoucherDisabled" 
                              type="submit" 
                              :size="'sm'" 
                              :variant="voucherButtonVariant" 
                              :white="voucherButtonColor" 
                              class="button-redeem" 
                              @click="redeem"
                          >
                              {{ voucherButtonText }}
                          </o-button>
                      </div>
                      <p v-if="!isExpired" class="modal-expiry">* Valid Until {{ expirationDate }}</p>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import {OButton} from '@/components/OmnihControl';
export default {
    components: {
        OButton
    },
  props: {
    voucher: {
      type: Object,
      required: true,
      default: () => ({
        name: '',
        point: 0,
        merchant: {
          name: ''
        },
        expiration: 0,
      })
    }
  },
  data() {
    return {
        isMobileView: window.innerWidth <= 768,
        isModalActive: false,
        modalPosition: { top: 0, left: 0 },
        isLoading: false,
        error: null,
    };
  },
  computed: {
    isExpired() {
        const currentDate = new Date();
        const expirationDate = new Date(this.voucher.expiration);
        return currentDate > expirationDate;
    },
    hasNegativePoints() {
        return this.voucher.memberPoint < 0;
    },
    isVoucherDisabled() {
        return this.isExpired || this.hasNegativePoints || this.voucher.point > this.voucher.memberPoint;
    },
    voucherButtonText() {
        if (this.hasNegativePoints) {
            return 'Points Negative';
        } else if (this.voucher.point > this.voucher.memberPoint) {
            return 'Not Enough';
        } else {
            return 'Redeem Now';
        }
    },
    voucherButtonVariant() {
        return this.isVoucherDisabled ? 'secondary' : 'primary';
    },
    voucherButtonColor() {
        return this.isVoucherDisabled ? 'black' : 'white';
    },
    expirationDate() {
      if (!this.voucher.expiration) return "No expiration date provided";

      const expirationDate = new Date(this.voucher.expiration);

      if (isNaN(expirationDate.getTime())) return "Invalid expiration date";

      const day = String(expirationDate.getDate()).padStart(2, '0');
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      const month = monthNames[expirationDate.getMonth()];
      const year = expirationDate.getFullYear();

      return `${day} ${month} ${year}`;
    },
    modalStyle() {
      return {
        top: `${this.modalPosition.top}px`,
        left: `${this.modalPosition.left}px`,
      };
    }
  },
  methods: {
    toggleModal() {
      this.isModalActive = !this.isModalActive;
      if (this.isModalActive) {
      this.$nextTick(() => {
        this.updateModalPosition();
      });
    }
    },
    handleClick(event) {
    const rect = event.currentTarget.getBoundingClientRect();
    this.modalPosition = {
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    };
    this.toggleModal();
  },
  updateModalPosition() {
    this.$nextTick(() => {
      const rect = this.$el.querySelector('.voucher-card').getBoundingClientRect();
      this.modalPosition = {
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      };
    });
  },
    redeem() {
        // Check for negative points before proceeding
        if (this.voucher.memberPoint < 0) {
            alert('Your points are negative. Please complete transactions to make your points positive before accessing vouchers.');
            return;
        }

        this.isLoading = true;
        const { cancellation_cutoff, expiration, cancelable } = this.voucher;
        let cancelableBefore = null;
        if (cancelable == 1 && cancellation_cutoff) {
            const expirationDate = new Date(expiration);
            const cutoffInMilliseconds = cancellation_cutoff * 1000;

            const cancelableBeforeDate = new Date(expirationDate.getTime() - cutoffInMilliseconds);
            
            const year = cancelableBeforeDate.getFullYear();
            const month = String(cancelableBeforeDate.getMonth() + 1).padStart(2, '0');
            const day = String(cancelableBeforeDate.getDate()).padStart(2, '0');
            const hours = String(cancelableBeforeDate.getHours()).padStart(2, '0');
            const minutes = String(cancelableBeforeDate.getMinutes()).padStart(2, '0');
            const seconds = String(cancelableBeforeDate.getSeconds()).padStart(2, '0');

            cancelableBefore = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
        const data = {
            merchant_id: this.voucher.merchant_id,
            memberDeal: true,
            quantity: 1,
            voucher_id: this.voucher.id,
            expiration: this.voucher.expiration,
            cancelable: this.voucher.cancelable,
            cancelable_before: cancelableBefore
        };

        if (data.quantity > 0 && data.quantity <= 10) {                                
            this.$store.dispatch('ClientVoucher/redeem', { data })
                .then(() => {
                    this.$router.push({ name: 'client_voucher' });
                })
                .catch((err) => {
                    if (err.response && err.response.status === 400) {
                        this.error = err.response.data.error;
                        this.isLoading = false;
                    } else {
                        this.error = "An error occurred. Please try again.";
                        this.isLoading = false;
                    }
                });
        } else {
            this.error = "Quantity must be between 1 and 10.";
            this.isLoading = false;
        }
    },
    closeModal() {
      this.isModalActive = false;
    },
    checkMobileView() {
      this.isMobileView = window.innerWidth <= 768;
    }
  },
  watch: {
    
    isModalActive(newVal) {
      if (newVal) {
        window.addEventListener('scroll', this.updateModalPosition);
        window.addEventListener('resize', this.updateModalPosition);
        window.addEventListener('mousemove', this.updateModalPosition); // Tambahkan mousemove jika kartu bergerak dinamis
        document.addEventListener('scroll', this.updateModalPosition, true); // Listen to scroll events on the document
      } else {
        window.removeEventListener('scroll', this.updateModalPosition);
        window.removeEventListener('resize', this.updateModalPosition);
        window.addEventListener('mousemove', this.updateModalPosition); // Tambahkan mousemove jika kartu bergerak dinamis
        document.removeEventListener('scroll', this.updateModalPosition, true); // Remove scroll event listener from the document
      }
    },
  },
  mounted() {
    this.updateModalPosition();
    window.addEventListener("resize", this.checkMobileView);
  },
  unmounted() {
    window.removeEventListener("resize", this.checkMobileView);
  },
};
</script>

<style scoped>
.disabled {
    background-color: #f0f0f0;
    color: #b0b0b0;
    cursor: not-allowed;
}
.voucher-card {
    position: relative;
    width: 500px;
    height: 550px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: none;
    padding: 0;
    background: none;
    text-align: left;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
}

.background-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}

.content-box {
    position: relative;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 450px;
}

  .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  width: 90%; /* Lebar responsif */
  max-width: 600px; /* Lebar maksimum untuk desktop */
  max-height: 90vh;
  border-radius: 25px; /* Membuat sudut membulat */
  overflow-y: auto; /* Untuk konten panjang */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent; /* Hilangkan background putih untuk mobile */
}
.modal-card {
  position: relative;
  width: 100%;
  max-width: 100%; /* Pastikan sesuai dengan lebar kontainer */
  border-radius: 12px;
  overflow: hidden;
}
.modal-voucher-image {
  width: 100%;
  height: 500px; /* Adjust the height of the image */
  object-fit: cover;
  display: block;
  border-radius: 12px; /* Adjust this value to control the curvature of the corners */
}

.modal-info-overlay {
  position: relative;
  width: 95%;
  background-color: white; /* Latar belakang putih hanya untuk desktop */
  border-radius: 12px;
  padding: 20px;
  overflow: hidden;
  margin-top:-100px;
}

.modal-info {
  position: relative;
  z-index: 1;
  overflow-wrap: break-word; /* Wrap long words to the next line */
  word-wrap: break-word; /* Compatibility with older browsers */
  word-break: break-word;
  text-align: center;
}

.modal-voucher-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #333;
  text-align: left;
}

.modal-voucher-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0 0 16px 0;
  text-align: left;
}
.info-section {
    margin-bottom: 30px;
    font-size: 14px;  /* Default size */
}

.info-section.centered-text {
    margin-bottom: -10px;
    font-size: 10px; /* Default size */
}


.title-points {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.voucher-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin: 0;
}

.info-and-points-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  background: #F1F1F1;
  gap: 20px;
  position: relative;
  border-width: 2px 0px 2px 0px;
  border-style: dashed;
  border-color: white;
  border-radius: 8px; 
  margin: 10px 0; 
  width: 100%; 
  box-sizing: border-box;
}

.points-box-container {
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: center; 
  text-align: center;
  min-width: 100px; 
  max-width: 150px; 
  overflow-wrap: break-word;
  word-wrap: break-word;
  text-overflow: ellipsis;
}

.points-box {
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.points-box-container{
  display: flex;
  flex-direction: column; 
  align-items: flex-end;
  min-width: 100px; 
  max-width: 100%;
  word-wrap: break-word; 
  overflow-wrap: break-word;
}

.points-text {
    font-size: 20px;
    font-weight: bold;
    color: #ff4b4b;
    margin: 0;
}
.points-label {
    font-size: 14px;
    color: #ff4b4b;
    margin: 0;
}
.points-texts {
    font-size: 40px;
    font-weight: bold;
    color: #ff4b4b;
    margin: 0;
}
.points-labels {
    font-size: 14px;
    color: #ff4b4b;
    margin: 0;
}
.voucher-subtitle {
    font-size: 14px;
    color: #666;
    margin: 0;
    margin-bottom: 4px;
}
.info-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 4px;
    color: #333;
}
.info-subtitle {
  flex: 1;
  font-size: 14px;
  color: #444;
  margin: 0;
  line-height: 1.4;
  text-align: left;
}
.modal-expiry {
  font-size: 12px;
  color: #999;
  text-align: center;
  margin: 0 0 20px 0;
  font-style: italic;
}
.info-text {
    font-size: 14px;
    color: #444;
}

.info-main-title {
    font-size: 14px;
    color: #ff4b4b;
    text-align: center;
}
.centered-text {
    text-align: center;
}
.italic-text {
    font-style: italic;
}
.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(255, 255, 255, 0.8);
    border: none;
    color: #333;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;
}

.close-button:hover {
    background: rgba(255, 255, 255, 1);
}
@media (max-width: 768px) {
  .voucher-card {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    padding: 16px;
    gap: 8px;
    flex-direction: row;
  }
  .background-image {
    position: relative;
    width: 40%;
    height: auto;
    object-fit: cover;
    border-radius: 8px;
    z-index: 1;
  }
  .content-box {
    flex-grow: 1; 
    padding: 0 8px;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .modal-overlay {
    background: rgba(0, 0, 0, 0.6); /* Background hitam semi-transparan */
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content-box {
    flex-grow: 1; /* Allow .content-box to take up the remaining space */
    height: 168px;
    margin-top: 0;
    padding: 0;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-voucher-image {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    border-radius: 8px;
    object-fit: cover;
  }
  .text-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    padding-left: 8px; 
    padding-right: 8px; 
}
  .voucher-title {
    font-size: 16px;
    line-height: 1.4;
    margin-bottom: 8px;
    padding-left: 4px; /* Slight padding for alignment */
  }
  .voucher-subtitle {
    font-size: 14px;
    line-height: 1.3;
    color: #666;
    margin-bottom: 8px;
    padding-left: 4px; /* Slight padding for alignment */
  }
  .expired-tag {
    font-size: 14px;
    margin-top: 12px;
    padding-left: 4px; /* Slight padding for alignment */
  }
  .modal-voucher-title {
    font-size: 16px;
  }

  .modal-voucher-subtitle {
    font-size: 14px;
  }

  .modal-expired-tag {
    font-size: 13px;
  }

  .points-texts {
    font-size: 20px; 
    word-break: break-word;
  }

  .info-subtitle {
    font-size: 13px; 
    line-height: 1.4;
  }
}
</style>